import React from "react";
import PropTypes from "prop-types";

var HeaderContainer = require("../layouts/header-container");
var Menu = require("../ui_elements/menu").Menu;
var MainMenu = require("../ui_elements/main-menu").MainMenu;
import Isvg from "../../../vendor/react-inlinesvg";

const getStoreLink = () => {
  const storeUrlObj = new URL(Fraction.Brand.Store.url);
  if (Fraction.Brand.Store.vstStore) {
    storeUrlObj.searchParams.set("utm_source", "bookshelfonline");
    storeUrlObj.searchParams.set("source", "bookshelf");
    storeUrlObj.searchParams.set("utm_campaign", "page_not_found")
  }
  return storeUrlObj.toString();
};

class ErrorContainer extends React.Component {
  constructor(props) {
    super(props);
    const browser = this._getBrowser();
    this.state = {
      ...this._getBrowserState(browser),
      delayRender: props.delayRender
    };

    this._redraw = this._redraw.bind(this);
    this._getBrowser = this._getBrowser.bind(this);
    this._redirectToLogin = this._redirectToLogin.bind(this);
    this._setSelectedBrowser = this._setSelectedBrowser.bind(this);
  }

  componentDidMount() {
    this._redirectIfNeeded();

    Fraction.Helpers.modalRedraw = this._redraw;

    // When switching between routers, we get a flash of our fallback which is the error page.
    this.delayRenderTimeout = setTimeout(
      () => this.setState({ delayRender: false }),
      100
    );
  }

  componentWillUnmount() {
    clearTimeout(this.delayRenderTimeout);
  }

  _needsRedirect() {
    return this.props.errorCode == 404 || this.props.errorCode == 500;
  }

  _redirectIfNeeded() {
    if (this._needsRedirect()) {
      const params = new URLSearchParams();
      params.set("locale", i18n.getCurrentLocale());
      //
      if (this.props.errorCode == 404) {
        params.set("theme", Fraction.Brand.Theme.primary);
        if (Fraction.Brand.Store.enabled) {
          params.set("storeLink", getStoreLink());
        }
        if (window.location.hash !== '#/system-error/404') {
          params.set("missingURL", window.location.href);          
        }
        window.location.replace(`/error/not-found?${params.toString()}`);
      } else if (this.props.errorCode == 500) {
        window.location.replace(`/error/system-error-space?${params.toString()}`);
      }
    }
  }

  _setSelectedBrowser(browser) {
    // Set support link and text based on selected browser
    const stateObject = this._getBrowserState(browser);
    this.setState(stateObject);
  }

  _getBrowserState(browser) {
    // Couple more checks needed for ie
    if (
      browser.indexOf("msie") > -1 ||
      browser.toLowerCase().indexOf("edge") > -1
    ) {
      browser = "ie";
    }

    switch (browser) {
      case "chrome":
        return {
          selectedBrowser: i18n.t("cookies.chrome"),
          browserSupportLink:
            "https://support.google.com/accounts/answer/61416",
          browserUnderlineIndex: 0
        };
      case "firefox":
        return {
          selectedBrowser: i18n.t("cookies.firefox"),
          browserSupportLink:
            "https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences",
          browserUnderlineIndex: 1
        };
      case "ie":
        return {
          selectedBrowser: i18n.t("cookies.ie"),
          browserSupportLink:
            "http://windows.microsoft.com/en-us/windows-vista/block-or-allow-cookies",
          browserUnderlineIndex: 2
        };
      case "safari":
        return {
          selectedBrowser: i18n.t("cookies.safari"),
          browserSupportLink: "https://support.apple.com/kb/PH19214",
          browserUnderlineIndex: 3
        };
      default:
        return {
          selectedBrowser: i18n.t("cookies.chrome"),
          browserSupportLink:
            "https://support.google.com/accounts/answer/61416",
          browserUnderlineIndex: 0
        };
    }
  }

  _getBrowser() {
    // src: http://stackoverflow.com/questions/2400935/browser-detection-in-javascript
    var ua = navigator.userAgent,
      tem,
      M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem !== null) {
        return tem
          .slice(1)
          .join(" ")
          .replace("OPR", "Opera");
      }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) !== null) {
      M.splice(1, 1, tem[1]);
    }
    return M[0].toLowerCase();
  }

  _redraw() {
    setTimeout(() => this.forceUpdate(), 0);
  }

  _redirectToLogin() {
    // Need to clear redirect since it sometimes gets set to `cookie-error` (not sure why)
    Fraction.Helpers.clearRedirect();
    Fraction.Router.setRoute("/user/signin");
  }

  render404() {
    return (
      <div className="error-container">
        {Fraction.Brand.Graphics.watkins && (
          <img src="/img/prop_laptop_dust.svg" />
        )}
        <div className="error-header">{i18n.t("messages.404-error")}</div>
        <div className="error-description">
          {toHTML(
            i18n.t("messages.404-error-subtext", {
              branded_url: brands.brand_name
            })
          )}
        </div>
      </div>
    );
  }

  render500() {
    return (
      <div className="error-container">
        {Fraction.Brand.Graphics.watkins && (
          <img src="/img/prop_laptop_no.svg" />
        )}
        <div className="error-header">{i18n.t("messages.500-error")}</div>
      </div>
    );
  }

  renderCokieError() {
    return (
      <div className="error-container cookie-error-container">
        <div className="cookie-error-aligner">
          <div className="error-header">{i18n.t("cookies.must-enable")}</div>
          <div className="error-description">
            {i18n.t("cookies.select-browser")}
          </div>
          <button
            className="error-back-to-signin submit"
            onClick={this._redirectToLogin}
          >
            {i18n.t("cookies.back-to-signin")}
          </button>
          <div className="error-browser-image-container">
            <img
              src="/img/chrome_icon.png"
              onClick={this._setSelectedBrowser.bind(this, "chrome")}
            />
            <img
              src="/img/firefox_icon.png"
              onClick={this._setSelectedBrowser.bind(this, "firefox")}
            />
            <img
              src="/img/internet_explorer_icon.png"
              onClick={this._setSelectedBrowser.bind(this, "ie")}
            />
            <img
              src="/img/safari_icon.png"
              onClick={this._setSelectedBrowser.bind(this, "safari")}
            />
          </div>
          <div
            className="browser-underline"
            data-underline-index={this.state.browserUnderlineIndex}
          />
          <div className="error-browser-text-container">
            {toHTML(
              i18n.t("cookies.to-enable-cookies", {
                browser: this.state.selectedBrowser,
                url: this.state.browserSupportLink
              })
            )}
          </div>
        </div>
      </div>
    );
  }

  renderErrorPage() {
    if (this.props.errorCode === 404) {
      return this.render404();
    } else if (this.props.errorCode === "cookie") {
      return this.renderCokieError();
    } else if (this.props.errorCode === 503) {
      return (
        <div className="maintenance-error">
          <div className="text-wrapper">
            <p className="big">{i18n.t("messages.503-error")}</p>
            <p className="small">{i18n.t("messages.503-error-subtext")}</p>
          </div>
          <img src="/img/maintenance.svg" />
        </div>
      );
    } else {
      return this.render500();
    }
  }

  render() {
    if (this.state.delayRender || this._needsRedirect()) {
      return null;
    }
    return (
      <div id="system-error-container">
        {Fraction.Helpers.modalToShow}

        <HeaderContainer
          hide={true}
          powerByPositionSt={this.state.powerByPositionSt}
          updatePowerByClass={this._updatePowerByClass}
        />

        {this.renderErrorPage()}

        <MainMenu
          powerByPositionSt={this.state.powerByPositionSt}
          updatePowerByClass={this._updatePowerByClass}
          environment="error-page"
        />
      </div>
    );
  }
}

ErrorContainer.propTypes = {
  errorCode: PropTypes.string.isRequired
};

ErrorContainer.defaultProps = {};

module.exports = ErrorContainer;
